import React, { memo } from 'react'

import { Button, Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const size = { width: '14px', height: '14px' }
const trashIcon = <Icon svgComponent={Trash} color="dark" size={size} notSpaced />

function PreviewWrap({ imageUrl, onRemovePreview: handleRemovePreview }) {
  return (
    <div className="image-uploader__preview-wrap">
      <img
        src={imageUrl}
        alt="Uploaded preview"
        className="image-uploader__preview"
        decoding="async"
      />
      <Button
        type="secondary"
        variant="only-icon"
        size="tiny"
        icon={trashIcon}
        customClass="image-uploader__remove"
        onClick={handleRemovePreview}
        aria-label="Remove image"
      />
    </div>
  )
}

PreviewWrap.propTypes = {
  imageUrl: string.isRequired,
  onRemovePreview: func.isRequired,
}

export default memo(PreviewWrap)
